import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { OverlayModule } from '@angular/cdk/overlay';

import { SedsPaginatorComponent } from './seds-paginator.component';
import { SedsPaginatorNumberDirective } from './directives/seds-paginator-number.directive';
@NgModule({
  declarations: [SedsPaginatorComponent, SedsPaginatorNumberDirective],
  imports: [CommonModule, MatPaginatorModule, MatButtonModule, MatSelectModule, OverlayModule],
  exports: [SedsPaginatorComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SedsPaginatorModule {}
